import client from 'client';
import { Caption } from 'activities/types';

export interface FetchOnDemandSession {
    availableHls: boolean;
    captions?: Caption[];
    recordingUrl: string;
}

export async function fetchOnDemandSession(
    eventId: number,
    sessionId: number
): Promise<FetchOnDemandSession> {
    return (
        await client().get(
            `/api/v2/agenda/events/${eventId}/sessions/${sessionId}/virtualSession/recording`
        )
    ).data as FetchOnDemandSession;
}
